import { sarViews, inputNames } from '../../constants';
const noMargins = () => ({
  marginTop: 0,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0
});
const someMargins = () => ({
  marginTop: 3,
  marginRight: 3,
  marginBottom: 3,
  marginLeft: 3
});
const somePaddings = () => ({
  paddingLeft: 5,
  paddingRight: 5,
  paddingTop: 5,
  paddingBottom: 5
});
const noPaddings = () => ({
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0
});
const fullWidth = () => ({
  type: '%',
  value: 100
});
const headerAndFooterRowSettings = () => ({
  background: '#f3f3f3',
  margin: noMargins(),
  padding: Object.assign({}, noPaddings(), {
    paddingLeft: 10,
    paddingRight: 10
  })
});
const standardRowSettings = () => ({
  width: {
    type: '%',
    value: 100
  },
  margin: noMargins(),
  padding: Object.assign({}, noPaddings(), {
    paddingLeft: 10,
    paddingRight: 10
  })
});
const standardInputRowSettings = () => Object.assign({}, standardRowSettings(), {
  padding: Object.assign({}, standardRowSettings().padding, {
    paddingTop: 5,
    paddingBottom: 5
  })
});
const splitInputRowSettings = () => Object.assign({}, standardInputRowSettings(), {
  align: 'space-between'
});
const sectionTextSettings = {
  align: 'center',
  font: {
    fontSize: 12,
    color: '#505050',
    fontFamily: 'arial, helvetica, sans-serif',
    fontWeight: 700
  },
  margin: noMargins(),
  padding: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0
  }
};
const form = {
  type: 'Sar',
  name: 'SAR form',
  id: sarViews.FORM,
  settings: {
    hiddenFields: []
  },
  children: [{
    type: 'Column',
    name: 'Form Column',
    settings: {
      margin: noMargins(),
      padding: noPaddings()
    },
    children: [{
      type: 'Row',
      name: 'Description Row',
      settings: Object.assign({}, {
        width: {
          type: '%',
          value: 100
        },
        margin: noMargins(),
        padding: Object.assign({}, noPaddings(), {
          paddingLeft: 10,
          paddingRight: 10
        }),
        background: '#f3f3f3'
      }, {
        padding: {
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 10,
          paddingRight: 10
        },
        width: {
          value: 100,
          type: '%'
        }
      }),
      children: [{
        type: 'Text',
        name: 'Description Text',
        settings: {
          text: 'Identify Your Information',
          align: 'center',
          font: {
            fontSize: 16,
            color: '#000000',
            fontFamily: 'arial, helvetica, sans-serif',
            fontWeight: 'bold'
          },
          margin: noMargins(),
          padding: {}
        },
        children: []
      }]
    }, {
      type: 'Row',
      name: 'Sub-description row',
      settings: Object.assign({}, standardRowSettings(), {
        padding: {
          paddingLeft: 10,
          paddingRight: 10,
          paddingTop: 10,
          paddingBottom: 10
        }
      }),
      children: [{
        type: 'Text',
        name: 'Sub-description Text',
        settings: {
          text: 'To identify you in our systems, please provide required information',
          font: {
            fontSize: 12,
            color: '#505050',
            fontFamily: 'arial, helvetica, sans-serif'
          },
          margin: noMargins(),
          padding: noPaddings(),
          width: fullWidth()
        },
        children: []
      }]
    }, {
      type: 'Column',
      name: 'Name and Address Column',
      settings: {
        margin: {},
        padding: {}
      },
      children: [{
        type: 'Row',
        name: 'Name and Address Row',
        settings: standardRowSettings(),
        children: [{
          type: 'Text',
          name: 'Sub-description Text',
          settings: Object.assign({}, sectionTextSettings, {
            text: 'Enter your name and address'
          }),
          children: []
        }]
      }, {
        type: 'Row',
        name: 'Name input row',
        settings: Object.assign({}, splitInputRowSettings()),
        children: [{
          type: 'Input',
          name: 'First Name Input',
          disableInBuilder: true,
          settings: {
            fieldName: inputNames.FIRST_NAME,
            labelValue: 'First Name',
            name: inputNames.FIRST_NAME,
            width: {
              value: 49,
              type: '%'
            },
            required: true
          },
          children: []
        }, {
          type: 'Input',
          name: 'Last Name Input',
          disableInBuilder: true,
          settings: {
            fieldName: inputNames.LAST_NAME,
            labelValue: 'Last Name',
            name: inputNames.LAST_NAME,
            width: {
              value: 49,
              type: '%'
            },
            required: true
          },
          children: []
        }]
      }]
    }, {
      type: 'Row',
      name: 'Email Row',
      settings: Object.assign({}, standardInputRowSettings()),
      children: [{
        type: 'Input',
        name: 'Email Input',
        disableInBuilder: true,
        settings: {
          fieldName: inputNames.EMAIL,
          labelValue: 'Email',
          name: inputNames.EMAIL,
          type: 'text',
          required: true
        },
        children: []
      }]
    }, {
      type: 'Row',
      name: 'Address Line 1 Row',
      settings: Object.assign({}, standardInputRowSettings()),
      children: [{
        type: 'Input',
        name: 'Address Line 1 Input',
        disableInBuilder: true,
        settings: {
          fieldName: 'address-line-1',
          labelValue: 'Address Line 1',
          name: 'address-line-1'
        },
        children: []
      }]
    }, {
      type: 'Row',
      name: 'Address Line 2 Row',
      settings: Object.assign({}, standardInputRowSettings()),
      children: [{
        type: 'Input',
        name: 'Address Line 2 Input',
        disableInBuilder: true,
        settings: {
          fieldName: 'address-line-2',
          labelValue: 'Address Line 2',
          name: 'address-line-2',
          type: 'text'
        },
        children: []
      }]
    }, {
      type: 'Row',
      name: 'Contact Info Description Row',
      settings: standardRowSettings(),
      children: [{
        type: 'Text',
        name: 'Contact Info Description Text',
        settings: Object.assign({}, {
          text: 'Contact Information'
        }, sectionTextSettings),
        children: []
      }]
    }, {
      type: 'Row',
      name: 'City and State Row',
      settings: Object.assign({}, splitInputRowSettings()),
      children: [{
        type: 'Input',
        name: 'City Input',
        disableInBuilder: true,
        settings: {
          type: 'text',
          labelValue: 'City',
          name: 'city',
          fieldName: 'city',
          width: {
            value: 49,
            type: '%'
          }
        },
        children: []
      }, {
        type: 'Input',
        name: 'State Input',
        disableInBuilder: true,
        settings: {
          type: 'text',
          labelValue: 'State',
          name: 'state',
          fieldName: 'state',
          width: {
            value: 49,
            type: '%'
          }
        },
        children: []
      }]
    }, {
      type: 'Row',
      name: 'Phone Row',
      settings: Object.assign({}, standardInputRowSettings()),
      children: [{
        type: 'Input',
        name: 'Phone Input',
        disableInBuilder: true,
        settings: {
          maxLength: 10,
          labelValue: 'Phone',
          name: 'phone',
          width: {
            type: '%',
            value: 49
          },
          fieldName: 'phone'
        },
        children: []
      }]
    }, {
      type: 'Row',
      name: 'SSN Text Row',
      settings: Object.assign({}, {
        width: {
          type: '%',
          value: 100
        },
        margin: noMargins(),
        padding: Object.assign({}, noPaddings(), {
          paddingLeft: 10,
          paddingRight: 10
        }),
        background: 'white'
      }),
      children: [{
        type: 'Text',
        name: 'SSN Text',
        settings: Object.assign({}, {
          text: 'SSN Information'
        }, ({}, sectionTextSettings)),
        children: []
      }]
    }, {
      type: 'Row',
      name: 'SSN Input Row',
      settings: Object.assign({}, standardInputRowSettings(), {
        background: 'white'
      }),
      children: [{
        type: 'Input',
        name: 'SSN Input',
        disableInBuilder: true,
        settings: {
          name: inputNames.SSN,
          fieldName: inputNames.SSN,
          maxLength: 4,
          labelValue: 'Last 4 Digits',
          width: {
            type: '%',
            value: 20
          }
        },
        children: []
      }]
    }]
  }, {
    type: 'Row',
    name: 'Footer Row',
    settings: Object.assign({}, headerAndFooterRowSettings(), {
      align: 'flex-end'
    }),
    children: [
    // {
    //   type: 'Button',
    //   name: 'Cancel Button',
    //   settings: {
    //     background: '#f3f3f3',
    //     text: 'Cancel',
    //     font: {
    //       color: '#505050',
    //       fontSize: 14
    //     }
    //   },
    //   children: []
    // },
    {
      type: 'SubmitButton',
      name: 'Submit Button',
      settings: {
        text: 'Submit My Request'
      },
      children: []
    }]
  }]
};
const success = {
  type: 'SuccessView',
  name: 'Sar Success View',
  id: sarViews.SUCCESS,
  settings: {},
  children: [{
    type: 'Column',
    name: 'Content',
    settings: {
      margin: someMargins(),
      width: {
        type: 'auto',
        value: 1
      }
    },
    children: [{
      type: 'Text',
      name: 'Title text',
      children: [],
      settings: {
        text: 'Submission Accepted!',
        padding: somePaddings(),
        margin: Object.assign({}, noMargins(), {
          marginBottom: 30,
          marginTop: 20
        }),
        font: {
          color: '#1caf43',
          fontWeight: 'bold',
          fontSize: 20
        }
      }
    }, {
      type: 'Text',
      name: 'Message',
      settings: {
        padding: somePaddings(),
        margin: noMargins(),
        font: {
          color: '#1f1f1f'
        },
        text: `
              <p>Thank you, you're submission has been accepted.</p>
              <p>
                <br/>
              </p>
              <p>
                Please give us 45 days to respond to your request. The below information serves as the receipt for this transaction. Please save this 
                information and do not share it with anyone. You will need this information to access our response to your request when it has been completed.
              </p>
              <p>
                <br/>
              </p>
              <p>
                If you have provided an email address, we will also send an identifying Information Submission Receipt.
              </p>
              <br/>
            `
      },
      children: []
    }, {
      type: 'Text',
      name: 'Request ID',
      id: 'request-id',
      settings: {
        margin: noMargins(),
        padding: somePaddings(),
        font: {
          color: '#1f1f1f'
        },
        text: 'Your request ID:'
      },
      children: []
    }]
  }, {
    type: 'Row',
    name: 'Footer row',
    settings: Object.assign({}, headerAndFooterRowSettings(), {
      padding: 10,
      align: 'flex-end',
      height: {
        type: 'px',
        value: 50
      }
    }),
    children: [
      // {
      //   type: 'Button',
      //   name: 'OK button',
      //   settings: {
      //     width: { type: 'px', value: 100 },
      //     text: 'OK'
      //   },
      //   children: []
      // }
    ]
  }]
};
const verificationError = {
  type: 'ErrorView',
  name: 'Verification Error View',
  id: sarViews.error.VERIFICATION,
  settings: {},
  children: [{
    type: 'Column',
    name: 'Content',
    settings: {
      margin: someMargins(),
      width: {
        type: 'auto',
        value: 1
      }
    },
    children: [{
      type: 'Text',
      name: 'Title text',
      settings: {
        text: 'Verification Error!',
        padding: somePaddings(),
        margin: Object.assign({}, noMargins(), {
          marginBottom: 30,
          marginTop: 20
        }),
        font: {
          color: '#f20a0a',
          fontWeight: 'bold',
          fontSize: 20
        }
      },
      children: []
    }, {
      type: 'Text',
      name: 'Message',
      settings: {
        padding: somePaddings(),
        margin: noMargins(),
        font: {
          color: '#1f1f1f'
        },
        text: `
              <p>You've exceeded the maximum allowed validation attempts. We can't complete the online validation.</p>
              <p>
                <br/>
              </p>
              <p>
                However, your request has been submitted to customer service. A customer service representative will get in touch with you to help you complete
                your identity verification.
              </p>
              <p>
                <br/>
              </p>
              <p>
                Please add additional comments if required
              </p>
              <br/>
            `
      },
      children: []
    }, {
      type: 'TextArea',
      name: 'Comment text area',
      settings: {
        fieldName: 'customerMessage',
        height: {
          type: 'px',
          value: 200
        },
        placeHolder: 'Additional Comments'
      },
      children: []
    }]
  }, {
    type: 'Row',
    name: 'Footer row',
    settings: Object.assign({}, headerAndFooterRowSettings(), {
      padding: somePaddings(),
      align: 'flex-end'
    }),
    children: [
    // {
    //   type: 'Button',
    //   name: 'Cancel button',
    //   settings: {
    //     background: '#f3f3f3',
    //     text: 'Cancel',
    //     font: {
    //       color: '#505050',
    //       fontSize: 14
    //     }
    //   },
    //   children: []
    // },
    {
      type: 'SubmitButton',
      name: 'OK button',
      settings: {
        width: {
          type: 'px',
          value: 100
        },
        text: 'OK'
      },
      children: []
    }]
  }]
};
const maxRequestsError = {
  type: 'ErrorView',
  name: 'Max requests error view',
  id: sarViews.error.MAX_REQUESTS,
  settings: {},
  children: [{
    type: 'Column',
    name: 'Content',
    settings: {
      margin: someMargins(),
      width: {
        type: 'auto',
        value: 1
      }
    },
    children: [{
      type: 'Text',
      name: 'Title text',
      settings: {
        text: 'Exceeding Maximum Requests',
        padding: somePaddings(),
        margin: Object.assign({}, noMargins(), {
          marginBottom: 30,
          marginTop: 20
        }),
        font: {
          color: '#f20a0a',
          fontWeight: 'bold',
          fontSize: 20
        }
      },
      children: []
    }, {
      type: 'Text',
      name: 'Message',
      settings: {
        padding: somePaddings(),
        margin: noMargins(),
        font: {
          color: '#1f1f1f'
        },
        text: `
              <p>
                It looks like you've already submitted two requests in the past 12 months. If you'd like to submit another request, please try resubmitting
                a new request after ${new Date().toLocaleString('default', {
          month: 'long'
        })} ${new Date().getFullYear() + 1}
              </p>
              <p>
                <br/>
                <br/>
              </p>
              <p>
                Please add additional comments if required
              </p>
              <br/>
            `
      },
      children: []
    }, {
      type: 'TextArea',
      name: 'Comment text area',
      settings: {
        fieldName: 'customerMessage',
        height: {
          type: 'px',
          value: 200
        },
        placeHolder: 'Additional Comments'
      },
      children: []
    }]
  }, {
    type: 'Row',
    name: 'Footer row',
    settings: Object.assign({}, headerAndFooterRowSettings(), {
      padding: noPaddings(),
      align: 'flex-end'
    }),
    children: [
    // {
    //   type: 'Button',
    //   name: 'Cancel button',
    //   settings: {
    //     background: '#f3f3f3',
    //     text: 'Cancel',
    //     font: {
    //       color: '#505050',
    //       fontSize: 14
    //     }
    //   },
    //   children: []
    // },
    {
      type: 'SubmitButton',
      name: 'OK button',
      settings: {
        width: {
          type: 'px',
          value: 100
        },
        text: 'OK'
      },
      children: []
    }]
  }]
};
const activeRequestError = {
  type: 'ErrorView',
  name: 'Active request error view',
  id: sarViews.error.ACTIVE_REQUEST,
  settings: {},
  children: [{
    type: 'Column',
    name: 'Content',
    settings: {
      margin: someMargins(),
      width: {
        type: 'auto',
        value: 1
      }
    },
    children: [{
      type: 'Text',
      name: 'Title text',
      settings: {
        text: 'You already have an active request!',
        padding: somePaddings(),
        margin: Object.assign({}, noMargins(), {
          marginBottom: 30,
          marginTop: 20
        }),
        font: {
          color: '#f20a0a',
          fontWeight: 'bold',
          fontSize: 20
        }
      },
      children: []
    }, {
      type: 'Text',
      name: 'Message',
      settings: {
        padding: somePaddings(),
        margin: noMargins(),
        font: {
          color: '#1f1f1f'
        },
        text: `
              <p>
                Your request is currently in progress and you'll be notified by email when the request has been completed.
              </p>
              <p>
                <br/>
                <br/>
              </p>
              <p>
                Please add additional comments if required
              </p>
              <br/>
            `
      },
      children: []
    }, {
      type: 'TextArea',
      name: 'Comment text area',
      settings: {
        fieldName: 'customerMessage',
        height: {
          type: 'px',
          value: 200
        },
        placeHolder: 'Additional Comments'
      },
      children: []
    }]
  }, {
    type: 'Row',
    name: 'Footer row',
    settings: Object.assign({}, headerAndFooterRowSettings(), {
      padding: noPaddings(),
      align: 'flex-end'
    }),
    children: [
    // {
    //   type: 'Button',
    //   name: 'Cancel button',
    //   settings: {
    //     background: '#f3f3f3',
    //     text: 'Cancel',
    //     font: {
    //       color: '#505050',
    //       fontSize: 14
    //     }
    //   },
    //   children: []
    // },
    {
      type: 'SubmitButton',
      name: 'OK button',
      settings: {
        width: {
          type: 'px',
          value: 100
        },
        text: 'OK'
      },
      children: []
    }]
  }]
};
export default [form, success, verificationError, maxRequestsError, activeRequestError];